import React from "react";
import { Link } from "react-router-dom";
import { getAllPosts } from "../blog";

const BlogList = () => {
  const posts = getAllPosts();

  if (posts.length === 0) {
    return (
      <div className="no-posts">
        <p>No blog posts yet. Check back soon!</p>
      </div>
    );
  }

  return (
    <div className="articles-section">
      <h2 className="section-title">Latest Articles</h2>
      <div className="articles-grid">
        {posts.map((post) => (
          <article key={post.slug} className="article-card">
            <div className="article-content">
              <h3 className="article-title">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h3>
              {post.excerpt && (
                <p className="article-excerpt">{post.excerpt}</p>
              )}
            </div>

            <div className="article-footer">
              <Link to={`/blog/${post.slug}`} className="read-more-bt">
                Read More →
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default BlogList;
